<div class="review-tool__container">
    <div class="side-nav__container">
        <!-- <button
            mat-button
            (click)="setCurrentView(Views.Profile)"
            routerLink="/profile/"
            class="side-nav__label"
            [ngClass]="{ 'side-nav__selected': currentView === Views.Profile }"
        >
            <mat-icon class="side-nav__icon">home</mat-icon>
            <span class="side-nav__heading">{{"Home" | translate}}</span>
        </button> -->
        <button
            mat-button
            (click)="setCurrentView(Views.Feed)"
            routerLink="/feed/"
            class="side-nav__label"
            [disabled]="!isFeatureEnabled('feed')"
            [matTooltip]="!isFeatureEnabled('feed') ? ('Coming soon' | translate) : ''"
            [class.side-nav__disabled]="!isFeatureEnabled('feed')"
            [matTooltipPosition]="'right'"
        >
            <mat-icon class="side-nav__icon">rss_feed</mat-icon>
            <span class="side-nav__heading">{{"Feed" | translate}}</span>
        </button>
        <button
            mat-button
            (click)="setCurrentView(Views.Chat)"
            routerLink="/messaging/"
            class="side-nav__label"
            [disabled]="!isFeatureEnabled('messaging')"
            [matTooltip]="!isFeatureEnabled('messaging') ? ('Coming soon' | translate) : ''"
            [class.side-nav__disabled]="!isFeatureEnabled('messaging')"
            [matTooltipPosition]="'right'"
        >
            <mat-icon class="side-nav__icon">chat</mat-icon>
            <span class="side-nav__heading">{{"Messaging" | translate}}</span>
            <!-- <span
                    class="chat-notification-icon"
                    *ngIf="hasNewMessage || unreadStatus"
            ></span> -->
        </button>
        
        <button
            mat-button
            (click)="setCurrentView(Views.Goals)"
            routerLink="/goals/"
            class="side-nav__label"
            [disabled]="!isFeatureEnabled('goals')"
            [matTooltip]="!isFeatureEnabled('goals') ? ('Coming soon' | translate) : ''"
            [class.side-nav__disabled]="!isFeatureEnabled('goals')"
            [matTooltipPosition]="'right'"
        >
            <mat-icon class="side-nav__icon">fact_check</mat-icon>
            <span class="side-nav__heading">{{"Goals" | translate}}</span>
        </button>
        <!-- <button
            mat-button
            disabled
            (click)="setCurrentView(Views.Profile)"
            [matTooltip]="'Coming soon' | translate"
            class="side-nav__label side-nav__disabled"
        >
            <mat-icon class="side-nav__icon">schedule</mat-icon>
            <span class="side-nav__heading">{{"Schedules" | translate}}</span>
        </button> -->
    </div>
    <div class="main-content__container">
        <router-outlet></router-outlet>
    </div>
</div>

